import * as React from 'react'
import Box from '@mui/material/Box'
import VendorsPageTitle from 'vendors/components/VendorsPageTitle'
import { useParams, Navigate } from 'react-router-dom'
import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineDot from '@mui/lab/TimelineDot'
import { TimelineOppositeContent } from '@mui/lab'
import { CircularProgress, Typography } from '@mui/material'
import { useHistoryTimelineQuery } from 'vendors/vendorManage/queries/useHistoryTimelineQuery'
import { useDate } from 'utils/useDate'
import ReactMarkdown from 'react-markdown'
import { useTranslation } from 'react-i18next'

const VendorManageHistoryTimeline: React.FC = () => {
  const { t } = useTranslation()
  const { formatDate } = useDate()

  const { vendorId } = useParams<{ vendorId: string }>()

  var { data = [], isLoading, isError } = useHistoryTimelineQuery(vendorId as string)

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError) {
    return <Navigate to="/error" replace />
  }

  return (
    <>
      <Box>
        <VendorsPageTitle>{t('management-history')}</VendorsPageTitle>
      </Box>
      <Timeline>
        {data.map((timelineItem) => (
          <TimelineItem key={timelineItem.timelineItemId}>
            <TimelineSeparator>
              <TimelineDot variant="outlined" color="primary" />
              <TimelineConnector sx={{ backgroundColor: 'primary.main', opacity: 0.4 }} />
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="body2" color="textSecondary">
                {`${formatDate(timelineItem.auditTrailTimeStamp, 'd.M.yyyy')} // ${
                  timelineItem.auditTrailCreatedByUserFirstName
                } ${timelineItem.auditTrailCreatedByUserLastName}`}
              </Typography>
              <ReactMarkdown>{timelineItem.content}</ReactMarkdown>
            </TimelineContent>
            <TimelineOppositeContent sx={{ flex: 0 }} />
          </TimelineItem>
        ))}
      </Timeline>
    </>
  )
}

export default VendorManageHistoryTimeline
